import React, { useEffect, useState } from "react";
import { Button, Card, Divider, Modal, Form, Input, Skeleton, Spin, Tooltip } from "antd";
import { EditOutlined, SaveOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import { cardStyles } from "./UserInfo";

import GeneralInformationService from "../../services/GeneralInformationService";
import TextArea from "antd/es/input/TextArea";
import alerts from "../../shared/alerts";

import UserInformation from './UserInfo';

import { permissionsList } from "./../../shared/permissions";
import PermissionValidator from "../../component/PermissionValidator";
import Avisos from "./Avisos";


export default function HomeInformacion() {
    const [infoModal, setInfoModal] = useState({ estatus: false, data: {} });
    const [loading, setLoading] = useState(false);
    const [informacion, setInformacion] = useState([]);

    useEffect(() => {
        getGeneralInformation();
    }, []);

    const getGeneralInformation = async () => {
        setLoading(true);
        const response = await GeneralInformationService.getGeneralInformation();
        setLoading(false);

        if (!response.success) return alerts.error("Información", response.message);;
        setInformacion(response.data);
    }

    const handleEdit = (item) => {
        setInfoModal({ estatus: true, data: item });
    }

    return (
        <div>
            <Avisos />
            <UserInformation />
            <Divider></Divider>
            <Spin delay={100} spinning={loading}  >
                <Row justify={"center"} gutter={[16, 16]} align="stretch">
                    {informacion.map((item, index) => (
                        <Col key={`informacion_${index}`} xs={24} lg={12}  >
                            <Card
                                title={item.titulo}
                                size="small"
                                styles={{ ...cardStyles.bodyStyle, header: { ...cardStyles.headStyle }, }}
                                extra={
                                    <PermissionValidator permissions={[permissionsList.EDITAR_MISION_VISION]} >
                                        <Tooltip title={`Editar ${item.titulo}`}>
                                            <Button type="primary" shape="circle" size="small" onClick={() => handleEdit(item)} icon={<EditOutlined />} />
                                        </Tooltip>
                                    </PermissionValidator>
                                }
                            >
                                <p style={{ textAlign: 'justify' }}>{item.contenido}<br /><br /></p>
                            </Card>
                        </Col>
                    ))
                    }
                </Row>
            </Spin> 
            <ModalEdit infoModal={infoModal} setInfoModal={setInfoModal} loading={loading} setLoading={setLoading} getGeneralInformation={getGeneralInformation} />
        </div>
    )
}


const ModalEdit = ({ infoModal, setInfoModal, loading, setLoading, getGeneralInformation }) => {
    const [form] = Form.useForm();


    useEffect(() => {
        if (infoModal.estatus && Object.keys(infoModal.data).length > 0) {
            form.setFieldsValue(infoModal.data);
        }
    }, [infoModal]);

    const handleOk = async () => {
        setLoading(true);
        const data = await form.validateFields();
        const data_edit = { ...data, id_informacion: infoModal.data.id_informacion };
        const response = await GeneralInformationService.updateGeneralInformation(data_edit);
        setLoading(false);

        if (!response.success) {
            alerts.error(`${infoModal?.data?.titulo}`, response.message);
            setInfoModal({ estatus: false });
            return;
        } else {
            alerts.success(`${infoModal?.data?.titulo}`, response.message);
            setInfoModal({ estatus: false });
            getGeneralInformation();
        }
    };

    const handleCancel = () => {
        form.resetFields();
        setInfoModal({ estatus: false });
    };


    return (
        <Modal
            title={`Editar ${infoModal?.data?.titulo}`}
            open={infoModal.estatus}
            onCancel={handleCancel}
            loading={loading}
            width={1000}
            footer={[
                <Button key="cancel" loading={loading} onClick={handleCancel}>
                    Cancelar
                </Button>,
                <Button key="ok" type="primary" loading={loading} onClick={handleOk}>
                    <SaveOutlined /> Guardar
                </Button>,
            ]}
        >
            <Form
                form={form}
                layout="vertical"
            >
                <Form.Item
                    name="titulo"
                    label="Titulo"
                    rules={[{ required: true }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="contenido"
                    label="Descripción"
                    rules={[{ required: true }]}
                >
                    <TextArea
                        rows={4} />
                </Form.Item>
            </Form>
        </Modal>
    )
}